import React from "react";
import type { CustomCellRendererProps } from "ag-grid-react";
import { Constants } from "@eagerdog/constants";

import styles from "./MoveUpsTab.module.scss";

export const StatusRenderer: React.FC<CustomCellRendererProps> = (props) => {
  const status = props.value as string;
  const isActive = status === Constants.move_up_status.active;

  return (
    <div className={styles.StatusRenderer}>
      <span className={`${styles.StatusBadge} ${isActive ? styles.active : styles.reversed}`}>
        {status}
      </span>
    </div>
  );
};
